import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import qrcode_detail from '../assets/imgs/new/qrcode-detail.png';
import { Redirect } from 'react-router';
import QRCode from 'qrcode.react';
import { useDispatch, useSelector } from 'react-redux';
import { getMemoirs } from '../redux/actions/memoir.action';
import {
	addQuantity,
	addToCart,
	removeFromCart,
	subQuantity,
} from '../redux/actions/orderqrcart.actions';
import { toast } from 'react-toastify';
import MainHeader from '../components/MainHeader';
import Checkout from '../components/Modals/Checkout';
import { customAlert } from '../redux/actions/alertActions';

function QrCodeOrder() {
	// As two maps are rendring so it double the amount for second, so for both we need different var
	let cartTotal = 0;
	// React Redux

	const { id } = useSelector(state => state.authUser);
	const { memoirs } = useSelector(state => state.memoir);
	const { qr_list } = useSelector(state => state.orderQrCart);
	const dispatch = useDispatch();

	const qrCodesBGColors = ['#DBC3A6', '#FBBB00', '#FF4B55'];
	const ls = JSON.parse(localStorage.getItem('QR_Data'));
	const [modals, setModals] = useState({
		payment1: false,
		confirmation: false,
		cartModal: false,
	});
	const [qty, setQty] = useState(1);
	const [material, setMaterial] = useState('');
	const [price, setPrice] = useState();
	const [checkOut, setCheckOut] = useState(false);
	const checkOutToggle = () => {
		setCheckOut(!checkOut);
	};
	const toggleModal = async name => {
		let newModal = JSON.parse(JSON.stringify(modals));
		for (let modal of Object.keys(newModal)) {
			if (modal != name) newModal[modal] = false;
		}
		newModal[name] = !newModal[name];
		setModals(newModal);
	};
	useEffect(() => {
		if (memoirs.length == 0) {
			dispatch(getMemoirs(id));
		}
	}, []);

	const getMemoirName = id => {
		if (id != undefined) {
			let obj = memoirs && memoirs.find(mem => mem.id == id);
			if (obj != null) {
				return obj.memoir_title;
			} else {
				return 'N/A';
			}
		} else {
			return 'N/A';
		}
	};

	return (
		<>
			<div className='container-fluid pt-3'>
				<MainHeader heading={'Creation of qr code'} />
				<Checkout isOpen={checkOut} checkOutToggle={checkOutToggle} />
				<hr />
				<h5 className='mt-3 text-lightpurple font-weight-semibold'>
					Preview
				</h5>
				<div className='row mt-4'>
					<div className='col-xl-8'>
						<div
							className='preview-wrapper mx-auto'
							style={{ width: 225 }}
						>
							<div className='preview mx-auto'>
								<div className='top-text'>{ls.topText}</div>
								<div
									className='p-4 m-0 text-center'
									style={{
										backgroundColor: ls.color,
									}}
								>
									<QRCode
										value={ls.qrValue}
										bgColor={ls.color}
										fgColor='#484E9C'
									/>
								</div>
								<div className='bottom-text'>
									{ls.bottomText}
								</div>
							</div>
							<div className='quantity d-flex alig-items-center'>
								<h6 className='font-weight-semibold m-0'>
									Quantity
								</h6>
								<div className='counter ml-auto d-flex align-items-center'>
									<button
										className='qt-control font-weight-bold border-0'
										disabled={qty <= 1}
										onClick={() => {
											setQty(qty - 1);
										}}
									>
										-
									</button>
									<span className='f-14 font-weight-bold'>
										{qty}
									</span>
									<button
										className='qt-control font-weight-bold border-0'
										onClick={() => {
											setQty(qty + 1);
										}}
									>
										+
									</button>
								</div>
							</div>
						</div>
						<h6 className='mt-5 font-weight-semibold text-center'>
							Select Material
						</h6>
						<div className='row mt-4 justify-content-center'>
							<div className='col-md-6'>
								<div className='row'>
									<div className='col'>
										<span className='d-flex'>
											<input
												type='radio'
												name='orderType'
												className='m-0 mt-1'
												value='Laminated'
												id='24.99'
												onChange={e => {
													setMaterial(e.target.value);
													setPrice(
														Number(e.target.id)
													);
												}}
											/>
											<span className='d-flex flex-column ml-3'>
												<h6 className='m-0'>
													Laminated
												</h6>
												<small
													className='m-0 font-weight-bold'
													style={{
														color: '#484E9C',
													}}
												>
													£24.99
												</small>
											</span>
										</span>
									</div>
									<div className='col'>
										<span className='d-flex'>
											<input
												type='radio'
												name='orderType'
												className='m-0 mt-1'
												value='Metal'
												id='28.99'
												onChange={e => {
													setMaterial(e.target.value);
													setPrice(
														Number(e.target.id)
													);
												}}
											/>
											<span className='d-flex flex-column ml-3'>
												<h6 className='m-0'>Metal</h6>
												<small
													className='m-0 font-weight-bold'
													style={{
														color: '#484E9C',
													}}
												>
													£28.99
												</small>
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className='d-block d-md-flex w-100 align-items-center mt-5 mb-4'>
							<button
								className='btn btn-outline mb-3 mb-md-0 f14 px-4 dashboard-btn'
								disabled={!price || !material}
								onClick={e => {
									e.preventDefault();
									let obj = {
										qty: qty,
										price: price,
										qrID: ls.qrID,
										material: material,
										memoirID: ls.memoir,
										color: ls.color,
										topText: ls.topText,
										bottomText: ls.bottomText,
										template: ls.template,
										qrValue: ls.qrValue,
									};
									if (qr_list) {
										let newObj = qr_list.find(
											qr => qr.memoirID == ls.memoir
										);
										console.log('object', newObj);
										if (newObj != undefined) {
											// toggleModal('payment1');
											checkOutToggle();
										} else {
											dispatch(addToCart(obj));
											// toggleModal('payment1');
											checkOutToggle();
										}
									} else {
										dispatch(addToCart(obj));
										// toggleModal('payment1');
										checkOutToggle();
									}
								}}
							>
								Proceed to check out
							</button>
							<br className='d-block d-md-none' />
							<button
								disabled={!price || !material}
								className='btn btn-outline ml-md-3 f14 px-4 dashboard-btn'
								onClick={e => {
									e.preventDefault();
									let obj = {
										qty: qty,
										price: price,
										qrID: ls.qrID,
										material: material,
										memoirID: ls.memoir,
										topText: ls.topText,
										bottomText: ls.bottomText,
										template: ls.template,
										qrValue: ls.qrValue,
										color: ls.color,
									};
									if (qr_list && qr_list.length > 0) {
										let newObj = qr_list.find(
											qr => qr.memoirID == ls.memoir
										);
										if (newObj != undefined) {
											// toast.warning(
											// 	'Item Already in Cart'
											// );
											dispatch(
												customAlert(
													true,
													'Item Already in Cart'
												)
											);
											setTimeout(() => {
												dispatch(
													customAlert(false, '')
												);
											}, 1500);
										}
									} else {
										dispatch(addToCart(obj));
									}
								}}
							>
								Add to cart
							</button>
						</div>
					</div>
					<div className='col-xl-4 mt-5 mt-lg-0'>
						<div className='right-content-wrapper'>
							<div className='content-image-wrapper'>
								<img
									src={qrcode_detail}
									className='content-image'
								/>
							</div>
							<h5 className='font-weight-bold mt-4 mb-0'>
								Bronze
							</h5>
						</div>
					</div>
				</div>
			</div>
			<Modal isOpen={modals.cartModal}>
				<ModalBody className='p-0'>
					<div className='cart'>
						<div className='text-right'>
							<i
								className='fa fa-times text-danger pointer m-3'
								onClick={() => toggleModal('cartModal')}
							></i>
						</div>
						<div className='modal-content-wrapper '>
							<h5 className='font-weight-bold'>
								My Shopping Cart
							</h5>
							<div className='cart-item'>
								<div className='cart-cols  f-12 text-muted'>
									<span>Product:</span>
									<span className='text-center'>
										Quantity
									</span>
									<span className='text-center'>Price</span>
									<span className='text-center'>Action</span>
								</div>
								{qr_list &&
									qr_list.map((qr_cart, index) => {
										cartTotal =
											cartTotal +
											qr_cart.price * qr_cart.qty;
										return (
											<Cart
												dispatch={dispatch}
												key={index}
												qr_cart={qr_cart}
												qrCodesBGColors={
													qrCodesBGColors
												}
												getMemoirName={getMemoirName}
											/>
										);
									})}
								<div
									style={{
										borderTop: '1px solid #00000040',
									}}
									className='mt-4 d-flex'
								>
									<h4 className='ml-auto pt-2 font-weight-bold'>
										Total:{' '}
										<span
											style={{
												color: '#D93D13',
											}}
										>
											£{cartTotal.toFixed(2)}
										</span>
									</h4>
								</div>
							</div>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</>
	);
}

const Cart = props => {
	let { qr_cart, qrCodesBGColors, getMemoirName, dispatch } = props;
	return (
		<>
			<div className='cart-cols header pt-2'>
				<span>
					<span className='d-flex align-items-center'>
						<div
							className='p-1 m-0 text-center'
							style={{
								backgroundColor:
									qrCodesBGColors[qr_cart.template],
								width: 74,
								height: 74,
							}}
						>
							<QRCode
								value={qr_cart.qrValue}
								bgColor={qrCodesBGColors[qr_cart.template]}
								fgColor='#484E9C'
								size={64}
							/>
							{/* <img
                              src={qrCode1}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            /> */}
						</div>
						<div className='ml-2 f-14'>
							<small className='d-block font-weight-bold'>
								QR Code
							</small>
							<small className='d-block f-12'>
								ID: {qr_cart.qrID}
							</small>
							<small className='d-block font-weight-bold'>
								Material: {qr_cart.material}
							</small>
						</div>
					</span>

					<small className='font-weight-bold f-12'>
						{getMemoirName(qr_cart.memoirID)}
					</small>
					<br />
					<small
						style={{
							fontSize: 10,
						}}
						className='d-flex flex-column'
					>
						<span>Top Text: {qr_cart.topText}</span>
						<span>Bottom Text: {qr_cart.bottomText}</span>
						<span>Template: {qr_cart.template + 1}</span>
					</small>
				</span>
				<span className='text-center'>
					<div className='counter ml-auto d-flex align-items-center'>
						<button
							className='qt-control font-weight-bold border-0'
							disabled={qr_cart.qty <= 1}
							onClick={() => {
								dispatch(subQuantity(qr_cart.memoirID));
							}}
						>
							-
						</button>
						<span className='f-14 font-weight-bold'>
							{qr_cart.qty}
						</span>
						<button
							className='qt-control font-weight-bold border-0'
							onClick={() => {
								dispatch(addQuantity(qr_cart.memoirID));
							}}
						>
							+
						</button>
					</div>
				</span>
				<span className='text-center'>
					<small className='font-weight-bold'>
						£{qr_cart.qty * qr_cart.price}
					</small>
				</span>
				<span className='text-center'>
					<small className='font-weight-bold'>
						<i
							className='fa fa-trash pointer text-danger'
							onClick={() => {
								dispatch(removeFromCart(qr_cart.memoirID));
							}}
						></i>
					</small>
				</span>
			</div>
		</>
	);
};

export default QrCodeOrder;
